import React from "react";
import AllSubjectTopics from "../../../topics/AllSubjectTopics";


function NcertBookChemTopics() {
  return (
    <>

      <AllSubjectTopics subject="chemistry" type="ncertbook" />


    </>
  );
}

export default NcertBookChemTopics;